import { create } from 'zustand';

export type PartnerType = "parti" | "media" | "ong" | "institution" | "sap" | "autre";

export interface PartnerSuggestion {
  id: string;
  partnerType: PartnerType;
  partnerName: string;
  subject: string;
  text: string;
  status: 'unread' | 'read';
  createdAt: string;
}

import { getApiUrl } from "@/utils/apiConfig";
const API_URL = getApiUrl();

interface SuggestionsState {
  suggestions: PartnerSuggestion[];
  fetchSuggestions: () => Promise<void>;
  addSuggestion: (suggestion: Omit<PartnerSuggestion, 'id' | 'status' | 'createdAt'>) => void;
  markAsRead: (id: string) => void;
  deleteSuggestion: (id: string) => void;
}

export const useSuggestionsStore = create<SuggestionsState>((set) => ({
  suggestions: [],
  
  fetchSuggestions: async () => {
    try {
      const res = await fetch(`${API_URL}/suggestions.php`);
      const data = await res.json();
      if (Array.isArray(data)) {
        set({ suggestions: data });
      }
    } catch (e) {
      console.error("Failed to fetch suggestions", e);
    }
  },

  addSuggestion: (newSug) => {
    set((state) => {
      const suggestion: PartnerSuggestion = {
        ...newSug,
        id: `sug_${Date.now()}`,
        status: 'unread',
        createdAt: new Date().toISOString()
      };
      
      fetch(`${API_URL}/suggestions.php`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ action: 'add', ...suggestion })
      });

      return { suggestions: [suggestion, ...state.suggestions] };
    });
  },

  markAsRead: (id) => {
    set((state) => {
      fetch(`${API_URL}/suggestions.php`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ action: 'markAsRead', id })
      });
      return { suggestions: state.suggestions.map(s => s.id === id ? { ...s, status: 'read' as const } : s) };
    });
  },

  deleteSuggestion: (id) => {
    set((state) => {
      fetch(`${API_URL}/suggestions.php`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ action: 'delete', id })
      });
      return { suggestions: state.suggestions.filter(s => s.id !== id) };
    });
  }
}));

// Initial fetch
if (typeof window !== "undefined") {
  useSuggestionsStore.getState().fetchSuggestions();
}
